<template lang="html">
  <div class="">
    <ul class="list-none">

      <li
        v-for="(x, index) in data"
        class="animation-bottom"
        :style="{animationDelay: (index / 20) + 's'}"
        :key="`exercise-${index}`"
      >
          <div class="game-books-list container wrap align-items-center justify-content-center"
               :class="{
                 finished: x.finished,
                 disabled: (!x.finished && x._id !== subTopic._id && !isReview && x.evaluable && !student.teens)
               }">
            <div class="index">
              {{index + 1}}
            </div>
            <div class="description">
              {{x.description}}
            </div>
            <div class="stars container column align-center ">
              <ul class="list-none container animation-bottom mobileAdjustsubT">
                <li><img src="@/assets/img/star-unit.svg" width="18" alt="" class="disable" :class="{ normal : x.points >= 20}"></li>
                <li><img src="@/assets/img/star-unit.svg" width="18" alt="" class="disable" :class="{ normal : x.points >= 40}"></li>
                <li><img src="@/assets/img/star-unit.svg" width="18" alt="" class="disable" :class="{ normal : x.points >= 51}"></li>
                <li><img src="@/assets/img/star-unit.svg" width="18" alt="" class="disable" :class="{ normal : x.points >= 75 }"></li>
                <li><img src="@/assets/img/star-unit.svg" width="18" alt="" class="disable" :class="{ normal : x.points == 100}"></li>
              </ul>
              <div class="animation-bottom full-width">
                <button class="btn btn-opacity btn-sm btn-rounded btn-full mobileAdjustsubT"
                        @click="viewSubTopic(x)"
                        v-if="x.finished || isReview">
                  PRACTICE <i class="margin-left-5 fas fa-arrow-right"></i>
                </button>
                <button class="btn btn-opacity btn-sm btn-rounded btn-full mobileAdjustsubT"
                        @click="viewSubTopic(x)"
                        v-else>
                  ENTER <i class="margin-left-5 fas fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
      </li>

    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { studentRef } from '../../store/firebase';

export default {
  props: {
    data: {
      type: Array
    }
  },
  computed: {
    ...mapGetters({
      subTopic: 'subTopic/get',
      isReview: 'isReview',
      revision: 'unit/revision',
      isSpeakUp: 'isSpeakUp',
      isSpeakUpFeedback: 'isSpeakUpFeedback',
      student: 'student/GET'
    })
  },
  methods: {
    async viewSubTopic (subTopic) {
      if (!!this.student.teens) {
        this.$store.dispatch('teens/setSubTopic', subTopic._id)

        return this.$router.push({ name: subTopic.type })
      }

      if (this.isSpeakUp) {
        return this.$router.push({
          name: `${subTopic.type}-speakup`,
          params: {
            ...this.$route.params,
            subtopic_id: subTopic._id
          }
        })
      }

      if (this.isSpeakUpFeedback) {
        return this.$router.push({
          name: `${subTopic.type}-speakup-feedback`,
          params: {
            ...this.$route.params,
            subtopic_id: subTopic._id
          },
          query: this.$route.query
        })
      }

      if (subTopic._id == this.subTopic._id || subTopic.finished || this.isReview || !subTopic.evaluable) {
        let path = subTopic.type

        if (this.isReview) path = `${path}-review`
        else if (this.revision) path = `${path}-revision`

        await this.$store.dispatch('subTopic/fetchSubTopic', subTopic._id)
        this.$router.push({ name: path })
      }
    }
  }
}
</script>

<style lang="scss">

.mobileAdjustsubT {
  @media (max-width: 440px){
    width: 100%!important;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    height: 40px;
  }
}

.disable {
    filter: grayscale(100%);
}
.normal {
    filter: grayscale(0);
}
.game-books-list {
    background: linear-gradient(90deg, #FFB52C, #FF6823);
    margin-bottom: 20px;
    border-radius: 18px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 6px 7px 0 rgba(0, 0, 0, 0.04);
    color: #fff;
    transition: 0.3s;
    .index {
        width: 25px;
        min-width: 25px;
        height: 25px;
        border-radius: 50%;
        background: #FF6823;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid #fff;
        font-size: 12px;
        font-weight: 700;
        margin: 7px;
        transition: 0.3s;
    }
    .description {
        flex-grow: 1;
        flex-basis: 200px;
        margin: 7px;
        font-weight: 300;
    }

    .stars {
        margin: 7px;
        @media (max-width: 440px){
          width: 100%;
          padding: 10px;
        }
        ul {
            background: red;
            margin-bottom: 5px;
            padding: 5px 10px;
            background: linear-gradient(180deg, #FFE600, #FF8000);
            box-sizing: border-box;
            border-radius: 20px;
            li {
                margin-right: 3px;
                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }

    &:hover {
        background: linear-gradient(90deg, #FF8000, #FF8000);
        .index {
            background: #FF8000;
        }
    }

    &.finished {
        background: linear-gradient(90deg, #00FFB1, #238B98);
        .index {
            background: #00B8A2;
        }

        &:hover {
            background: linear-gradient(90deg, #238B98, #238B98);
            .index {
                background: #238B98;
            }
        }
    }

    &.disabled {
        background: linear-gradient(90deg, #C5C5C5, #9D9D9D);
        .index {
            background: #9D9D9D;
        }

        .stars {
            ul {
                background: linear-gradient(180deg, #C5C5C5, #C5C5C5);
            }
            .btn {
                cursor: not-allowed;;
            }
        }
        &:hover {
          cursor: not-allowed;
        }
    }

    @media (max-width: 820px) {
        flex-wrap: wrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game/exerciciesVertical.vue